import { isEmpty } from 'lodash';

let container;
let originX = 0;
let originY = 0;
let originTransformX = 0;
let originTransformY = 0;
let isDragging = false;

const imageMouseOver = e => {
  container.classList.add('canZoom');
};

const imageMouseOut = e => {
  container.classList.remove('canZoom');
};

const imageMouseDown = e => {
  isDragging = true;
  originX = e.offsetX;
  originY = e.offsetY;
  if (!isEmpty(container.style.transformOrigin)) {
    const origin = container.style.transformOrigin.split(' ').map(value => {
      return parseInt(value, 10);
    });
    [originTransformX, originTransformY] = origin;
  }
};

const imageMouseUp = () => {
  isDragging = false;
  originX = 0;
  originY = 0;
  originTransformX = 0;
  originTransformY = 0;
};

const imageMouseMove = e => {
  if (isDragging && !isEmpty(container.style.transformOrigin)) {
    container.style.transformOrigin = `${originTransformX +
      (originX - e.offsetX)}px ${originTransformY + (originY - e.offsetY)}px 0`;
  }
};

const processZoom = (el, type) => {
  const daltaZoom = type === 'up' ? 0.1 : -0.1;
  const currentZoom = el.dataset.zoom;
  const newZoom = Number.parseFloat(currentZoom) + daltaZoom;

  // Max / Min zoom
  if (newZoom > 4.1 || newZoom < 1) {
    return;
  }

  el.dataset.zoom = newZoom;
  el.style.transform = `scale(${newZoom})`;
};

const mouseWheel = e => {
  if (container.classList.contains('canZoom')) {
    e.preventDefault();
    // set transform origin
    container.style.transformOrigin = `${e.offsetX}px ${e.offsetY}px 0px`;
    const type = e.deltaY > 0 ? 'down' : 'up';
    processZoom(container, type);
  }
};

/**
 * @param el
 * @constructor
 */
export const ApplyZoom = el => {
  container = el;
  // Add attr data-zoom
  if (!el.getAttribute('data-zoom')) {
    el.setAttribute('data-zoom', 1);
  }

  /* Event mouseOver */
  el.addEventListener('mouseover', imageMouseOver);
  /* Event mouseOut */
  el.addEventListener('mouseout', imageMouseOut);

  el.addEventListener('mousedown', imageMouseDown);
  el.addEventListener('mousemove', imageMouseMove);

  window.addEventListener('mouseup', imageMouseUp);

  /* Event wheel */
  window.addEventListener('wheel', mouseWheel);
};

/**
 *
 * @param el
 * @constructor
 */
export const RemoveZoom = () => {
  if (container) {
    container.removeEventListener('mouseover', imageMouseOver);
    container.removeEventListener('mouseout', imageMouseOut);
    container.removeEventListener('mousedown', imageMouseDown);
    container.removeEventListener('mousemove', imageMouseMove);

    window.removeEventListener('mouseup', imageMouseUp);
    window.removeEventListener('wheel', mouseWheel);

    container.dataset.zoom = 1;
    container.style.transformOrigin = 'none';
    container.style.transform = 'none';
  }
};



// WEBPACK FOOTER //
// ./src/lib/Zoom.js